import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const TransferStockForm = forwardRef(({ids, entity, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={entity}
      type="entity"
      fieldsComponent={Fields}
      onSave={useCallback(({location}) => services.stockItem.transferItems(ids, location), [services, ids])}
      onSaved={onSaved}
    />
  );
});

export default TransferStockForm;
